import { Card, Link, Pane, Paragraph } from 'evergreen-ui'

import Flex from '~/components/Flex'
import Image from '~/components/Image'
import { ISite } from '~/interfaces/netlify/Site'

type Props = {
  handleClick: Function
  site: ISite
}

const providerMap = {
  github: 'GitHub',
  gitlab: 'GitLab',
}

export default function NetlifySite(props: Props) {
  const { site, handleClick } = props

  return (
    <Card
      key={site.id}
      background="white"
      cursor="pointer"
      elevation={1}
      hoverElevation={2}
      marginBottom={8}
      onClick={() => handleClick(site.id)}
      padding={8}
      position="relative"
      width="100%"
    >
      <Flex>
        <Flex justifyContent="flex-start">
          <Image alt="" borderRadius={5} height="75" src={site.screenshotURL} width={120} />
          <Pane marginLeft={12}>
            <Pane>
              <Link size={500}>{site.name}</Link>
              <Paragraph color="muted" size={300}>
                {site.accountName}&nbsp;&nbsp;·&nbsp;&nbsp;Deploys from {providerMap[site.vcs] || 'Unknown'}
              </Paragraph>
            </Pane>
          </Pane>
        </Flex>
      </Flex>
    </Card>
  )
}
